export const SHEET_ANIMATION = {
	duration: 0.45,
	ease: [0.32, 0.72, 0, 1] as const,
} as const;
